import {
  Armour,
  BaseResource,
  BuffOrDebuff,
  GameSystem,
  PermanentInjury,
  Spell,
  TreasureItem,
  Weapon,
} from '../types';

export interface ReferenceCatalog {
  weapons: Weapon[];
  armours: Armour[];
  buffs: BuffOrDebuff[];
  treasureItems: TreasureItem[];
  baseResources: BaseResource[];
  injuries: PermanentInjury[];
  spells: Spell[];
}

export const getReferenceCatalog = (
  gameSystem: GameSystem,
  frostgraveCatalog: ReferenceCatalog
): ReferenceCatalog => {
  if (gameSystem === 'frostgrave') return frostgraveCatalog;

  return {
    weapons: [],
    armours: [],
    buffs: [],
    treasureItems: [],
    baseResources: [],
    injuries: [],
    spells: [],
  };
};